import { useQuery } from "@tanstack/react-query";

import { listConstructions } from "@/adapters/api";
import { type Obra, toObra } from "@/features/stages/obra.ts";

const MAX_PAGE_SIZE = 100;

export function useObras() {
	return useQuery({
		queryKey: ["obras"],
		queryFn: async (): Promise<Obra[]> => {
			const { items } = await listConstructions({ pageSize: MAX_PAGE_SIZE });
			return items.map(toObra);
		},
		staleTime: 60_000,
	});
}
